import * as Sentry from '@sentry/vue';
import type * as Vue from 'vue';

import { ConsoleLoggerAdapter } from '#ui-shared/utils/logger/adapters/ConsoleAdapter';
import { SentryAdapter } from '#ui-shared/utils/logger/adapters/SentryAdapter';
import { appLogger } from '#ui-shared/utils/logger/LoggerClass';

/**
 * Initializes logging, by initializing Sentry and registering all desired logger adapters to the appLogger.
 */
export function bootstrapLogging(app: Vue.App<Element>): void {
  Sentry.init({
    app,
    environment: SentryAdapter.generateEnvironmentStringForSentry(),
    release: SentryAdapter.getReleaseVersionForSentry(),
    dsn: SentryAdapter.getSentryDSN(),
    sendDefaultPii: SentryAdapter.shouldSendDefaultPiiToSentry(),
    enableLogs: true,
    enabled: SentryAdapter.isSentryEnabled(),
    // Set this to true if you want to see Sentry logs in the console for debugging purposes. Remember to set it back to false in production to avoid exposing sensitive information.
    debug: false,
  });

  /*
  * Register all desired logger adapters here. The appLogger will use these adapters to log messages. You can create custom adapters by implementing the LoggerAdapter interface and then register them here.
  * */
  appLogger.registerAdapter(new ConsoleLoggerAdapter({
    isEnabled: ConsoleLoggerAdapter.isConsoleLogEnabled(),
  }));
  appLogger.registerAdapter(new SentryAdapter());
}
